(function () {
  var BASE = "/apps/ai";
  var SESSION_KEY = "saisho_design_session";
  var SELECTOR = "[data-saisho-quick-buy]";

  function eventElement(event) {
    return event.target instanceof Element ? event.target : null;
  }

  function getSessionToken() {
    try {
      var existing = window.localStorage.getItem(SESSION_KEY);
      if (existing) return existing;
      var token = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : String(Date.now()) + "-" + Math.random().toString(16).slice(2);
      window.localStorage.setItem(SESSION_KEY, token);
      return token;
    } catch (_error) {
      return null;
    }
  }

  function parsePayload(button) {
    try {
      return JSON.parse(button.getAttribute("data-saisho-quick-buy") || "{}");
    } catch (_error) {
      return {};
    }
  }

  function absoluteUrl(url) {
    if (!url) return "";
    try {
      return new URL(url, window.location.href).href;
    } catch (_error) {
      return "";
    }
  }

  function previewUrlFor(button, payload) {
    var tile = button.closest("[data-saisho-quick-buy-tile]") || button.closest("article");
    var image = tile && tile.querySelector("img");
    return absoluteUrl((image && (image.currentSrc || image.src)) || payload.preview_url);
  }

  async function createStockDesign(payload) {
    var response = await fetch(BASE + "/designs/stock", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("stock design failed: " + response.status);
    return response.json();
  }

  async function addToCart(payload, design) {
    var response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: Number(payload.variant_id),
            quantity: 1,
            properties: {
              _design_id: design.id,
              _preview_url: design.preview_url || payload.preview_url,
              Size: payload.size_label,
            },
          },
        ],
      }),
    });
    if (!response.ok) throw new Error("cart add failed: " + response.status);
    return response.json();
  }

  function setButtonState(button, label) {
    if (!button.dataset.saishoOriginalHtml) {
      button.dataset.saishoOriginalHtml = button.innerHTML;
    }
    button.disabled = true;
    button.classList.add("is-loading");
    button.textContent = label;
  }

  function restoreButton(button, label) {
    button.disabled = false;
    button.classList.remove("is-loading");
    if (label) {
      button.textContent = label;
      window.setTimeout(function () {
        button.innerHTML = button.dataset.saishoOriginalHtml || button.innerHTML;
      }, 1800);
      return;
    }
    button.innerHTML = button.dataset.saishoOriginalHtml || button.innerHTML;
  }

  document.addEventListener("click", async function (event) {
    var target = eventElement(event);
    var button = target && target.closest(SELECTOR);
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var payload = parsePayload(button);
    var previewUrl = previewUrlFor(button, payload);
    if (!payload.gallery_item_id && (!payload.variant_id || !previewUrl)) {
      restoreButton(button, "Unavailable");
      return;
    }

    if (previewUrl) payload.preview_url = previewUrl;
    payload.cart_token = payload.cart_token || getSessionToken();

    setButtonState(button, "Adding...");
    try {
      var design = await createStockDesign(payload);
      payload.variant_id = payload.variant_id || design.variant_id;
      payload.preview_url = design.preview_url || payload.preview_url;
      if (!payload.variant_id || !payload.preview_url) throw new Error("stock design missing cart data");
      await addToCart(payload, design);
      window.location.href = "/cart";
    } catch (error) {
      console.error("[saisho-quick-buy]", error);
      restoreButton(button, "Try again");
    }
  });
})();
